import { css } from 'aphrodite';
import * as React from 'react';
import { useMeeting } from '../contexts/meeting';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
}

/**
 * Everyone besides the host whose calendar is folded into the availability shown. Read-only: teammates are
 * chosen in the app when the booking is started, and this page is served anonymously.
 */
export const ScheduleMeetingInternalAttendees: React.FC<IProps> = ({ className = '' }) => {
	const { meeting } = useMeeting();

	const names = [...(meeting?.additionalHosts ?? []), ...(meeting?.selectedHosts ?? [])].filter(Boolean);

	if (!names.length) {
		return null;
	}

	return (
		<div className={`${css(styleSheet.container)} ${className}`}>
			<p className={css(styleSheet.label)}>Also attending</p>
			<p className={css(styleSheet.names)}>{names.join(', ')}</p>
		</div>
	);
};
